module.exports = __webpack_public_path__ + "static/media/login.0ebea30e.jpg";